<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-12">
        <div class="font-bold mb-10">PT Commission Setting</div>
        <div class="box-mini mb-10">
          <div class="row p-15 pb-0">
            <div class="col-md-7">
              <a @click="openPage('/ptReport/ptCommissionSetting/add')" class="btn-primary mr-5"><i class="fas fa-plus-square mr-5"></i>Add</a>
            </div>
          </div>
          <hr class="mb-0">
          <div class="p-15">
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive :items="items" :fields="fields" class="table-fixedwidth text-center">
              <template v-slot:cell(personal_training.name)="data">
                {{ data.item.personal_training ? data.item.personal_training.name : '-' }}
              </template>
              <template v-slot:cell(use_club_achievement)="data">
                <span :class="data.item.use_club_achievement ? 'color-success' : 'color-danger'">
                  {{ data.item.use_club_achievement ? 'Yes' : 'No (excluded)' }}
                </span>
              </template>
              <template v-slot:cell(action)="data">
                <b-button size="sm" @click="openPage('/ptReport/ptCommissionSetting/add?id=' + data.item.personal_trainer_id)" class="btn-table green">
                  <i class="fas fa-pen font-12 mr-5"></i>Edit
                </b-button>
                <b-button size="sm" @click="deleteData(data.item.personal_trainer_id)" class="btn-table danger">
                  <i class="fas fa-times font-12 mr-5"></i>Delete
                </b-button>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ptCommissionSettingIndex',
  props: {
    hover: { type: Boolean, default: true },
    striped: { type: Boolean, default: true },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data: function () {
    return {
      fields: [
        { key: 'personal_training.name', label: 'Personal Trainer' },
        { key: 'personal_training.branch.name', label: 'Branch' },
        { key: 'use_club_achievement', label: 'Pakai Cap Club Achievement' },
        { key: 'note', label: 'Note' },
        { key: 'action', label: 'Action' }
      ],
      items: []
    }
  },
  methods: {
    openPage (event) {
      this.$router.push(event)
    },
    deleteData (personal_trainer_id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Setting ini akan dihapus, PT akan kembali kena aturan cap club achievement standar.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {
          axios.delete('crm/v1/pt_commission_setting/' + personal_trainer_id).then(() => {
            this.$swal('Deleted', 'Setting berhasil dihapus', 'success')
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
            this.$swal('Error', 'Gagal menghapus setting', 'error')
          })
        }
      })
    },
    fetchData () {
      axios.get('crm/v1/pt_commission_setting').then(response => {
        this.items = response.data.data
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
